import gql from 'graphql-tag'

export const InserAdminMessage = gql`
  mutation InserAdminMessage($message: String!) {
    insert_notifyAdmin_one(object: {message: $message}) {
      id
    }
  }
`;
